// extracted by mini-css-extract-plugin
export default {"branchTooltip":"BranchTooltip_branchTooltip__A9WrB"};